export const colorUtils = {
    methods: {
        getTrafficLightColor(min, max, value) {
            const minColor = { r: 0, g: 150, b: 136 }; // Green
            const maxColor = { r: 255, g: 82, b: 82 }; // Red

            let absValue = Math.abs(value);

            const percentage = Math.min(
                Math.max((absValue - min) / (max - min), 0),
                1
            );

            const red = Math.round(
                minColor.r + (maxColor.r - minColor.r) * percentage
            );
            const green = Math.round(
                minColor.g + (maxColor.g - minColor.g) * percentage
            );
            const blue = Math.round(
                minColor.b + (maxColor.b - minColor.b) * percentage
            );

            return `rgb(${red}, ${green}, ${blue})`;
        },
        getThreeZoneTrafficLightColor(min, mid, max, value) {
            const minColor = { r: 0, g: 150, b: 136 }; // Green
            const midColor = { r: 255, g: 255, b: 0 }; // Yellow
            const maxColor = { r: 255, g: 82, b: 82 }; // Red

            let absValue = Math.abs(value);

            let colorStart, colorEnd, percentage;

            if (absValue <= mid) {
                percentage = Math.min(
                    Math.max((absValue - min) / (mid - min), 0),
                    1
                );
                colorStart = minColor;
                colorEnd = midColor;
            } else {
                percentage = Math.min(
                    Math.max((absValue - mid) / (max - mid), 0),
                    1
                );
                colorStart = midColor;
                colorEnd = maxColor;
            }

            const red = Math.round(
                colorStart.r + (colorEnd.r - colorStart.r) * percentage
            );
            const green = Math.round(
                colorStart.g + (colorEnd.g - colorStart.g) * percentage
            );
            const blue = Math.round(
                colorStart.b + (colorEnd.b - colorStart.b) * percentage
            );

            return `rgb(${red}, ${green}, ${blue})`;
        }
    }
};
